<template>
  <div>
    <Information></Information>
  </div>
</template>

<script>
import Information from '../MInformationService'
export default {
  data() {
    return {
     
    }
  },
  components: {Information}
}
</script>

<style>
</style>
